import { useEffect } from 'react'

import { IS_SSR } from '@web/libs/utils'

export const isFirstPage = () => {
  if (IS_SSR) return false

  if (window.history.state?.firstPage) return true

  return false
}
export const useGlobalFirstPage = () => {
  useEffect(() => {
    // 히스토리 길이가 1이고 firstPage 상태가 없을 때만 첫 방문으로 설정
    if (window.history.length === 1 && !window.history.state?.firstPage) {
      const state = { ...window.history.state, firstPage: true }
      window.history.replaceState(state, '')
    }
  }, [])
}

export const FirstPageStateTag = () => {
  return (
    <script
      dangerouslySetInnerHTML={{
        __html: `
        const originalReplaceState = window.history.replaceState;

        // Next.js에서 state를 덮여씌우는 로직이 있어서 firstPage state만 replaceState시에 유지하기 위해 몽키패치
        window.history.replaceState = function (state, title, url) {
          const previousState = window.history.state || {};

          // 이전 상태에서 firstPage 가져와서 merge
          const mergedState = {
            ...state,
            ...(previousState.hasOwnProperty('firstPage') 
              ? { firstPage: previousState.firstPage } 
              : {})
          };

          return originalReplaceState.call(this, mergedState, title, url);
        };       
        `,
      }}
    />
  )
}
